/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type SelfReadingStatus = 'Undefined' | 'Created' | 'SentToDistributor' | 'Approved' | 'Rejected' | 'Canceled';

export const SelfReadingStatus = {
    Undefined: 'Undefined' as SelfReadingStatus,
    Created: 'Created' as SelfReadingStatus,
    SentToDistributor: 'SentToDistributor' as SelfReadingStatus,
    Approved: 'Approved' as SelfReadingStatus,
    Rejected: 'Rejected' as SelfReadingStatus,
    Canceled: 'Canceled' as SelfReadingStatus
};